<template>
  <div v-if="item">
    <CustomCallout
      :border-left-color="item.status.color"
      :controlled="true"
      :opened="calloutIsOpen"
      @click:open="toggleCallout(enums.SHOW_ITEMS.STATUS_TIMELINE)"
    >
      <template #default>
        <div class="row py-3 pr-4" :style="{ 'min-height': '140px' }">
          <div class="col-12 col-lg-2 border-right">
            <div
              class="d-flex flex-column h-100 align-items-center justify-content-around"
            >
              <Chip :color="item.status.color">
                <span v-text="item.status.text" />
              </Chip>
              <div class="mt-2">
                <span v-text="item.requestType || '-'" />
              </div>
              <div class="mt-2">
                <span v-text="item.requestNumber || '-'" />
              </div>
            </div>
          </div>
          <div class="col mt-2 mt-lg-0">
            <div class="row">
              <div class="col-12 col-sm-6 col-lg-4 mt-2 mt-lg-1">
                <div class="regular text-gray">Estudiante:</div>
                <span
                  class="regular"
                  v-text="`${item.student.sie} - ${item.student.name}`"
                />
              </div>
              <div class="col-12 col-sm-6 col-lg-4 mt-2 mt-lg-1">
                <div class="regular text-gray">Solicitante:</div>
                <span class="regular" v-text="item.requester.name || '-'" />
              </div>
              <div class="col-12 col-sm-6 col-lg-4 mt-2 mt-lg-1">
                <div class="regular text-gray">Puesto de Solicitante:</div>
                <span class="regular" v-text="item.requester.position || '-'" />
              </div>
              <div class="col-12 mt-2 d-none d-lg-block" />
              <div class="col-12 col-sm-6 col-lg-4 mt-2 mt-lg-1">
                <div class="regular text-gray">Determinación:</div>
                <span
                  class="regular"
                  v-text="item.determinationTypeName || '-'"
                />
              </div>
              <div class="col-12 col-sm-6 col-lg-4 mt-2 mt-lg-1">
                <div class="regular text-gray">Centro/Municipio:</div>
                <span class="regular" v-text="item.location?.center || '-'" />
                <span
                  class="regular"
                  v-text="'/' + (item.location?.municipality || '-')"
                />
              </div>
              <div class="col-12 col-sm-6 col-lg-4 mt-2 mt-lg-1">
                <div class="regular text-gray">Escuela:</div>
                <span
                  class="regular"
                  v-text="
                    `${item.location?.school?.code || '-'} - ${item.location
                      ?.school?.name || '-'}`
                  "
                />
              </div>
              <div class="col-12 col-sm-6 col-lg-4 mt-2 mt-lg-1">
                <div class="regular text-gray">Escuela de Consulta:</div>
                <span class="regular">
                  {{ item.requestSchool }}
                </span>
              </div>
              <div class="col-12 col-sm-6 col-lg-4 mt-2 mt-lg-1"></div>
              <div
                v-if="item.hasRetroactivePaymentAuthorization === true"
                class="col-12 col-sm-6 col-lg-4 mt-2 mt-lg-1 d-flex align-items-center"
              >
                <badge
                  :value="item.hasRetroactivePaymentAuthorization"
                  text="Pago Retroactivo"
                  class="retroactive-badge"
                />
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-2 mt-2 mt-lg-0">
            <div class="text-right">
              <div class="dropdown">
                <button
                  v-if="!showYellowMessage || canViewNotifiedAndPrintLetter"
                  class="btn btn-dropdown-actions dropdown-toggle pt-1"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Acciones
                </button>
                <div class="dropdown-menu dropdown-menu-right">
                  <button
                    v-if="
                      !isAssistantOrProvider &&
                        !canViewNotifiedAndPrintLetter &&
                        !isConversion
                    "
                    type="button"
                    class="dropdown-item cursor-pointer"
                    @click.stop="$emit('enter', item)"
                  >
                    <i class="fas fa-file-import fa-fw text-green mr-2" />
                    <span>Entrar</span>
                  </button>
                  <template v-if="isAssignedToTeacher && isAssistantOrProvider">
                    <div class="dropdown-divider mx-3" />
                    <button
                      type="button"
                      class="dropdown-item cursor-pointer"
                      @click="toggleCallout(enums.SHOW_ITEMS.STATUS_TIMELINE)"
                    >
                      <i class="fas fa-file-search fa-fw text-green mr-2" />
                      <span>Información Adicional</span>
                    </button>
                  </template>
                  <template
                    v-if="
                      (isAssignedToTeacher &&
                        isAssistantOrProvider &&
                        isAssigned) ||
                        canAmendNotifiedRequest
                    "
                  >
                    <div class="dropdown-divider mx-3" />
                    <button
                      type="button"
                      class="dropdown-item cursor-pointer"
                      @click="toggleCallout(enums.SHOW_ITEMS.AMENDMENT)"
                    >
                      <i class="fas fa-file-plus fa-fw text-green mr-2" />
                      <span>Enmendar</span>
                    </button>
                  </template>
                  <template v-if="canReturnStatus">
                    <div class="dropdown-divider mx-3" />
                    <button
                      type="button"
                      class="dropdown-item cursor-pointer"
                      @click="$emit('return-status', item)"
                    >
                      <i class="fas fa-arrow-left fa-fw text-green mr-2" />
                      <span>Regresar Estatus Anterior</span>
                    </button>
                  </template>
                  <template v-if="isApproved">
                    <div class="dropdown-divider mx-3" />
                    <button
                      type="button"
                      class="dropdown-item cursor-pointer"
                      @click="notifyRequest()"
                    >
                      <i class="fas fa-flag fa-fw text-green mr-2" />
                      <span>Notificado</span>
                    </button>
                  </template>
                  <template
                    v-if="
                      !estatusNuevo &&
                        !isAssistantOrProvider &&
                        !isNoValidityEgress &&
                        !canViewNotifiedAndPrintLetter &&
                        !isConversion
                    "
                  >
                    <div class="dropdown-divider mx-3" />
                    <button
                      type="button"
                      class="dropdown-item cursor-pointer"
                      @click="$emit('goToObservations', item)"
                    >
                      <i class="fas fa-file-search fa-fw text-green mr-2" />
                      <span>Observaciones</span>
                    </button>
                  </template>
                  <template>
                    <div class="dropdown-divider mx-3" />
                    <button
                      type="button"
                      class="dropdown-item cursor-pointer"
                      @click="$emit('goToHistory', item)"
                    >
                      <i class="fas fa-history fa-fw text-green mr-2" />
                      <span>Historial de Consulta</span>
                    </button>
                  </template>

                  <template v-if="!!item.student?.sie">
                    <div class="dropdown-divider mx-3" />
                    <button
                      type="button"
                      class="dropdown-item cursor-pointer"
                      @click="handleCommentHistoryRedirect(item)"
                    >
                      <i class="fas fa-file-alt text-green mr-2" />
                      <span>Comentario</span>
                    </button>
                  </template>

                  <template v-if="isApprovedDirectPayment">
                    <div class="dropdown-divider mx-3" />
                    <button
                      type="button"
                      class="dropdown-item cursor-pointer"
                      @click="downloadDirectPaymentReport()"
                    >
                      <i class="fas fa-file-download fa-fw text-green mr-2" />
                      <span>Descargar Aprobación por Pago Directo</span>
                    </button>
                  </template>
                  <template v-if="isApproved && !canViewNotifiedAndPrintLetter">
                    <div class="dropdown-divider mx-3" />
                    <button
                      type="button"
                      class="dropdown-item cursor-pointer"
                      @click="toggleCallout(enums.SHOW_ITEMS.SIGNED_APPROVAL)"
                    >
                      <i class="fas fa-file-download fa-fw text-green mr-2" />
                      <span v-if="isApproved">
                        {{
                          item.signedApprovalDocumentId ? 'Descargar' : 'Añadir'
                        }}
                        aprobación firmada
                      </span>
                    </button>
                  </template>
                  <template v-if="isNotified && item.signedApprovalDocumentId">
                    <div class="dropdown-divider mx-3" />
                    <button
                      type="button"
                      class="dropdown-item cursor-pointer"
                      @click="getSignedApprovalDocument"
                    >
                      <i class="fas fa-file-download fa-fw text-green mr-2" />
                      <span>Descargar aprobación firmada</span>
                    </button>
                  </template>
                  <template
                    v-if="
                      (isNotified || isAssigned) &&
                        companyId != null &&
                        hasAssignmentPermission
                    "
                  >
                    <button
                      type="button"
                      class="dropdown-item cursor-pointer"
                      @click="toogleAssigment()"
                    >
                      <i class="fas fa-user-plus fa-fw text-green mr-2" />
                      <span>
                        {{ isNotified ? 'Asignación' : 'Modificar Asignación' }}
                      </span>
                    </button>
                  </template>
                  <template v-if="hasBeenApproved && isAssistantOrProvider">
                    <button
                      type="button"
                      class="dropdown-item cursor-pointer"
                      @click="
                        toggleCallout(
                          enums.SHOW_ITEMS.STATUS_TIMELINE,
                          alternativeLocationTabIdx
                        )
                      "
                    >
                      <i class="fas fa-user-alt fa-fw text-green mr-2" />
                      <span>Alternativa de Ubicación</span>
                    </button>
                    <button
                      v-if="!isApproved"
                      type="button"
                      class="dropdown-item cursor-pointer"
                      @click="
                        toggleCallout(
                          enums.SHOW_ITEMS.STATUS_TIMELINE,
                          serviceSummaryTabIdx
                        )
                      "
                    >
                      <i class="fas fa-list fa-fw text-green mr-2" />
                      <span>Resumen de Servicios</span>
                    </button>
                  </template>
                  <button
                    v-if="showAmendmentDocument"
                    type="button"
                    class="dropdown-item cursor-pointer"
                    @click="
                      toggleCallout(
                        enums.SHOW_ITEMS.STATUS_TIMELINE,
                        enums.TAB_ITEMS.Fourth
                      )
                    "
                  >
                    <em class="fas fa-file-download fa-fw text-green mr-2" />
                    <span>Documento de Enmienda</span>
                  </button>
                  <template v-if="isApprovedRefund">
                    <div class="dropdown-divider mx-3" />
                    <button
                      type="button"
                      class="dropdown-item cursor-pointer"
                      @click="downloadRefundReport()"
                    >
                      <i class="fas fa-file-download fa-fw text-green mr-2" />
                      <span>Descargar Aprobación por Reembolso</span>
                    </button>
                  </template>
                  <template v-if="isApprovedPurchaseService">
                    <div class="dropdown-divider mx-3" />
                    <button
                      type="button"
                      class="dropdown-item cursor-pointer"
                      @click="downloadPurchaseService(item.id)"
                    >
                      <i class="fas fa-file-download fa-fw text-green mr-2" />
                      <span>Descargar Aprobación por Compra de Servicios</span>
                    </button>
                  </template>
                  <template v-if="isSubmitted">
                    <div class="dropdown-divider mx-3" />
                    <button
                      type="button"
                      class="dropdown-item cursor-pointer"
                      @click="downloadRequestReport()"
                    >
                      <i class="fas fa-sync-alt fa-fw text-green mr-2" />
                      <span>Imprimir Solicitud</span>
                    </button>
                  </template>
                  <template
                    v-if="
                      canPrintAnalysis &&
                        !isAssistantOrProvider &&
                        !isConversion
                    "
                  >
                    <div class="dropdown-divider mx-3" />
                    <button
                      type="button"
                      class="dropdown-item cursor-pointer"
                      @click="downloadRequestReport()"
                    >
                      <i class="fas fa-sync-alt fa-fw text-green mr-2" />
                      <span>Imprimir Análisis de la Solicitud</span>
                    </button>
                  </template>
                  <template v-if="(isAssigned || isNotified) && !isConversion">
                    <div class="dropdown-divider mx-3" />
                    <button
                      type="button"
                      class="dropdown-item cursor-pointer"
                      @click="$emit('goToTransferManagement', item)"
                    >
                      <i class="fas fa-repeat-alt fa-fw text-green mr-2" />
                      <span>Manejo de Traslado</span>
                    </button>
                  </template>
                  <template
                    v-if="isAssigned || isNoVigenteBaja || isNoValidityEgress"
                  >
                    <div class="dropdown-divider mx-3" />
                    <button
                      type="button"
                      class="dropdown-item cursor-pointer"
                      @click="$emit('goToTransferHistory', item)"
                    >
                      <i class="fas fa-history fa-fw text-green mr-2" />
                      <span>Historial de Traslado</span>
                    </button>
                  </template>
                  <template v-if="canShowApproveLetterHistory">
                    <div class="dropdown-divider mx-3" />
                    <button
                      type="button"
                      class="dropdown-item cursor-pointer"
                      @click="
                        toggleCallout(
                          enums.SHOW_ITEMS.APPROVE_LETTER_HISTORY,
                          enums.TAB_ITEMS.Sixth
                        )
                      "
                    >
                      <i class="fas fa-history fa-fw text-green mr-2" />
                      <span>Historial de Cartas de Aprobación</span>
                    </button>
                  </template>
                  <template v-if="showRecommendedCentralLevel">
                    <div class="dropdown-divider mx-3" />
                    <button
                      type="button"
                      class="dropdown-item cursor-pointer"
                      @click.stop="
                        $emit(
                          'change-status-to-central-level-recommended',
                          item
                        )
                      "
                    >
                      <i class="fas fa-sync-alt fa-fw text-green mr-2" />
                      <span>Recomendado a Nivel Central</span>
                    </button>
                  </template>

                  <template v-if="showChangeToAmendProcess">
                    <div class="dropdown-divider mx-3" />
                    <button
                      type="button"
                      class="dropdown-item cursor-pointer"
                      @click.stop="
                        $emit('change-status-to-amend-process', item)
                      "
                    >
                      <i class="fas fa-sync-alt fa-fw text-green mr-2" />
                      <span>Proceso de Enmienda</span>
                    </button>
                  </template>
                  <template v-if="showAmendmentHistory">
                    <div class="dropdown-divider mx-3" />
                    <button
                      type="button"
                      class="dropdown-item cursor-pointer"
                      @click.stop="$emit('show-amendment-history', item)"
                    >
                      <i class="fas fa-sync-alt fa-fw text-green mr-2" />
                      <span>Historial de Enmienda</span>
                    </button>
                  </template>
                  <template v-if="canReturnCentralLevel">
                    <div class="dropdown-divider mx-3" />
                    <button
                      type="button"
                      class="dropdown-item cursor-pointer"
                      @click.stop="openReturnCentralLevelPanel"
                    >
                      <i class="fas fa-reply text-green mr-2" />
                      <span>Devolver a Nivel Central</span>
                    </button>
                  </template>
                  <template v-if="canUpdateDirectorName">
                    <div class="dropdown-divider mx-3" />
                    <button
                      type="button"
                      class="dropdown-item cursor-pointer"
                      @click="
                        toggleCallout(
                          enums.SHOW_ITEMS.STATUS_TIMELINE,
                          directorNameTabIdx
                        )
                      "
                    >
                      <i class="fas fa-user-edit fa-fw text-green mr-2" />
                      <span>Actualizar Nombre de Director(a)</span>
                    </button>
                  </template>
                  <template v-if="canRevertEgress">
                    <div class="dropdown-divider mx-3" />
                    <button
                      type="button"
                      class="dropdown-item cursor-pointer"
                      @click="openRevertEgressPanel"
                    >
                      <i class="fas fa-undo-alt fa-fw text-green mr-2" />
                      <span>Revertir Egreso</span>
                    </button>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>

      <template #edition>
        <template v-if="showingRevertEgress">
          <div class="bg-gray p-2">
            <div class="bg-light-gray rounded pt-1 pl-2 pr-2 pb-2">
              <div class="bg-white rounded mt-1 px-4 py-2">
                <ValidationObserver ref="revertEgressForm">
                  <div class="row">
                    <div class="col-12 font-weight-bold mb-2">
                      Razón de cambio de estatus
                    </div>
                    <div class="col-12">
                      <ValidationProvider
                        v-slot="{ errors }"
                        mode="eager"
                        rules="required"
                      >
                        <custom-text-area
                          v-model="revertEgressReason"
                          :clearable="false"
                          custom-error-msg="El comentario es requerido."
                          :error="errors[0]"
                          label="Comentario:"
                          :maxlength="3000"
                          show-char-count
                          :count-classes="['d-block text-right']"
                          :rows="2"
                        />
                      </ValidationProvider>
                    </div>
                    <div class="col-12 mt-3 d-flex justify-content-end">
                      <action-button
                        class="ml-2 px-4 mb-3"
                        variant="outline-danger"
                        i="fas fa-times-circle"
                        text="Cancelar"
                        @click="cancelRevertEgress"
                      />
                      <action-button
                        type="button"
                        text="Guardar"
                        i="fas fa-save"
                        variant="success"
                        class="ml-2 px-4 mb-3"
                        @click="saveRevertEgress"
                      />
                    </div>
                  </div>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="isChangeToCentralLevelStatusOpened">
          <div class="bg-gray p-2">
            <div class="bg-light-gray rounded pt-1 pl-2 pr-2 pb-2">
              <div class="bg-white rounded mt-1 px-4 py-2">
                <ValidationObserver ref="returnStatusForm">
                  <div class="row">
                    <div class="col-12">
                      <ValidationProvider
                        v-slot="{ errors }"
                        mode="eager"
                        rules="required"
                      >
                        <custom-text-area
                          v-model="changeNewStatusComment"
                          :clearable="false"
                          custom-error-msg="Favor de documentar el comentario."
                          :error="errors[0]"
                          label="Comentario:"
                          :maxlength="3000"
                          show-char-count
                          :count-classes="['d-block text-right']"
                          :rows="2"
                        />
                      </ValidationProvider>
                    </div>
                    <div class="col-12 mt-3 d-flex justify-content-end">
                      <action-button
                        class="ml-2 px-4 mb-3"
                        variant="outline-danger"
                        i="fas fa-times-circle"
                        text="Cancelar"
                        @click="
                          () => {
                            showing = null;
                            isChangeToCentralLevelStatusOpened = false;
                          }
                        "
                      />
                      <action-button
                        type="button"
                        text="Guardar"
                        i="fas fa-save"
                        variant="success"
                        class="ml-2 px-4 mb-3"
                        @click="saveChangeReturnToCentralLevelStatus"
                      />
                    </div>
                  </div>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </template>
        <div v-else class="additional-container">
          <div class="p2 mt-1">
            <div class="bg-gray p-2">
              <div class="bg-white p-3 rounded pl-c-xl">
                <div v-if="!hasBeenApproved">
                  <custom-tab
                    content-class="mt-3"
                    :default-active-tab="activeTab"
                    :no-nav-style="true"
                    nav-class="nav-vue-underline"
                  >
                    <custom-tab-item
                      v-if="showHistoryTab"
                      class="mt-2"
                      title="Historial de Estatus"
                      lazy
                    >
                      <status-timeline :history="item.history" />
                    </custom-tab-item>
                    <custom-tab-item
                      v-if="showDeniedReazon"
                      class="mt-2"
                      title="Razón de Denegación"
                      lazy
                    >
                      <div class="pt-3 px-3">
                        <label class="input-label">Comentario:</label>
                        <p>{{ item?.comment }}</p>
                      </div>
                    </custom-tab-item>
                  </custom-tab>
                </div>
                <custom-tab
                  v-else
                  content-class="mt-3"
                  :default-active-tab="activeTab"
                  :no-nav-style="true"
                  nav-class="nav-vue-underline"
                >
                  <custom-tab-item
                    v-if="isAssignedToTeacher"
                    class="mt-2"
                    title="Información Adicional"
                  >
                    <teacher-assignment-display
                      :existing-data="item.assignedData"
                    />
                  </custom-tab-item>
                  <custom-tab-item
                    v-if="isAmend"
                    class="mt-2"
                    title="Información Enmendado"
                  >
                    <amendment :existing-data="item.amendmentData" readonly />
                  </custom-tab-item>
                  <custom-tab-item
                    v-if="showHistoryTab"
                    class="mt-2"
                    title="Historial del Estatus"
                    lazy
                  >
                    <status-timeline :history="item.history" />
                  </custom-tab-item>
                  <custom-tab-item
                    class="mt-2"
                    v-if="!showYellowMessage"
                    title="Alternativa de Ubicación"
                    lazy
                  >
                    <detail-generator
                      col-gutter="mb-2"
                      :details="alternativeLocation(item.alternativeLocation)"
                    />
                  </custom-tab-item>
                  <custom-tab-item
                    class="mt-2"
                    v-if="!showYellowMessage"
                    title="Resumen de Servicios"
                    lazy
                  >
                    <service-summary :data="item.serviceResume" />
                  </custom-tab-item>
                  <custom-tab-item
                    v-if="canShowApproveLetterHistory"
                    class="mt-2"
                    title="Historial de Cartas de Aprobación"
                    lazy
                  >
                    <div>
                      <ApprovedLetterHistory
                        :items="approveLetters"
                        @on-visible="getApproveLetterHistory"
                        @on-download-letter="downloadPurchaseService"
                      />
                    </div>
                  </custom-tab-item>
                  <custom-tab-item
                    v-if="showAmendmentDocument"
                    class="mt-2"
                    title="Documento de Enmienda"
                    lazy
                  >
                    <amendment
                      title="Documento de Enmienda"
                      :existing-data="item.amendmentData"
                      readonly
                    />
                  </custom-tab-item>
                  <custom-tab-item
                    v-if="canUpdateDirectorName"
                    class="mt-2"
                    title="Actualizar Nombre del Director(a)"
                    lazy
                  >
                    <UpdateDirectorName
                      :tap-request-id="item.id"
                      @cancel="showing = null"
                      @success="showing = null"
                    />
                  </custom-tab-item>
                </custom-tab>
              </div>
            </div>
          </div>
        </div>
      </template>
    </CustomCallout>
    <Error
      is-alert-mode
      v-if="showAmendedMessage"
      message="Esta consulta fue generada a través del proceso de enmienda"
      class="mt-0"
    />
    <ChangerOfStatusNotify
      v-if="showingNotifyStatus"
      class="mt-1"
      :tap-request-id="item.id"
      @cancel="showing = null"
      @success="
        toggleCallout();
        $emit('status-has-changed');
      "
    />

    <ChangeOfStatusSignedApproval
      v-if="showingSignedApproval"
      class="mt-1"
      :tap-request-id="item.id"
      @cancel="showing = null"
      @success="
        toggleCallout();
        $emit('status-has-changed');
      "
    />
    <TeacherAssignment
      v-if="showingTeacherAssignment"
      class="mt-1"
      :tap-request-id="item.id"
      :academic-year-id="item.academicYearId"
      :readonly="!(isNotified || isAssigned)"
      :existing-data="item.assignedData"
      :has-assistance-service-in-service-resume="
        item.hasAssistanceServiceInServiceResume
      "
      :min-start-date="teacherAssignmentMinStartDate"
      @cancel="showing = null"
      @success="
        toggleCallout();
        $emit('status-has-changed');
      "
    />

    <Amendment
      v-if="showingAmendment"
      class="mt-1"
      :tap-request-id="item.id"
      :assigned-date="item.assignedDate"
      @cancel="showing = null"
      @success="
        toggleCallout();
        $emit('on-amendment-success');
      "
    />
    <div v-if="showYellowMessage" class="container-message d-flex">
      <i class="fas fa-bell-exclamation font-25 pt-3 pl-3 " />
      <p class="pt-3 pl-3">
        La consulta {{ item.requestNumber }} fue creada para la solicitud de
        reembolso y no para la determinación de ubicación.
      </p>
    </div>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import { CustomTab, CustomTabItem } from 'custom-tabs';
import {
  tapRequestStatusesEnum,
  determinationTypeEnum,
  requesTypes,
} from '@/components/pei/ubication-tech-assistance/_types';
import {
  getTapRequestRefundReport,
  getTapRequestDirectPayment,
  getTapRequestPurchaseService,
  getTapRequestReport,
} from '../../../_api.js';
import {
  getTapRequestHistoryDetails as _getTapRequestHistoryDetails,
  getTabRequestApproveLetterHistory,
  changeStatus as _changeStatus,
} from '@/services/api/tapRequest.api.js';
import {
  ChangerOfStatusNotify,
  ChangeOfStatusSignedApproval,
} from '@/components/pei/ubication-tech-assistance/_components';
import StatusTimeline from './StatusTimeline';
import TeacherAssignment from './TeacherAssignment';
import DetailGenerator from './DetailGenerator';
import ServiceSummary from './ServiceSummary';
import TeacherAssignmentDisplay from './TeacherAssignmentDisplay';
import Amendment from './Amendment.vue';
import UpdateDirectorName from './UpdateDirectorName.vue';
import Chip from './Chip';
import store from '@/store/index';
import DocumentsService from '@/services/documents';
import userRoles from '@/utils/constants/userRoles';
import alert from '@/mixin/alert.mixin';
import moment from 'moment';
import commentTypes from '@/utils/constants/comment/commentTypes';
import Error from '@/components/common/Error.vue';
import ApprovedLetterHistory from './ApprovedLetterHistory.vue';
import CustomTextArea from 'CustomTextArea';
import ActionButton from 'ActionButton';
import Badge from '@/components/common/Badge';
import revertEgressMixin, {
  REVERT_EGRESS_SHOW_ITEM,
} from './revertEgress.mixin';

const SHOW_ITEMS = {
  STATUS_TIMELINE: 'STATUS_TIMELINE',
  NOTIFY_STATUS: 'NOTIFY_STATUS',
  SIGNED_APPROVAL: 'SIGNED_APPROVAL',
  TEACHER_ASSIGNMENT: 'TEACHER_ASSIGNMENT',
  AMENDMENT: 'AMENDMENT',
  APPROVE_LETTER_HISTORY: 'APPROVE_LETTER_HISTORY',
  RETURN_TO_CENTRAL_LEVEL: 'RETURN_TO_CENTRAL_LEVEL',
  REVERT_EGRESS: REVERT_EGRESS_SHOW_ITEM,
};

const TAB_ITEMS = {
  First: 0,
  Second: 1,
  Third: 2,
  Fourth: 3,
  Fiveth: 4,
  Sixth: 5,
};

export default {
  name: 'SearchResultItem',
  mixins: [alert, revertEgressMixin],
  components: {
    CustomCallout,
    CustomTab,
    CustomTabItem,
    Chip,
    StatusTimeline,
    ChangerOfStatusNotify,
    ChangeOfStatusSignedApproval,
    TeacherAssignment,
    TeacherAssignmentDisplay,
    Amendment,
    UpdateDirectorName,
    DetailGenerator,
    ServiceSummary,
    Error,
    ApprovedLetterHistory,
    CustomTextArea,
    ActionButton,
    Badge,
    // Documents,
  },
  props: {
    itemResult: { type: Object, required: true, default: null },
    statusFilter: {
      type: Number,
      default: null,
    },
  },
  data: () => ({
    item: null,
    opened: false,
    enums: { SHOW_ITEMS, TAB_ITEMS },
    activeTab: TAB_ITEMS.First,
    showing: null,
    notifyStatus: false,
    showSignedApproval: false,
    showAssignmentForm: false,
    documentLength: 0,
    documentsReadOnly: false,
    document: {
      documentTypes: [],
      // Variables to save component data.
      data: {
        files: [],
        types: [],
      },
    },
    hasAssignmentPermission: store.getters.HasPermission(
      'taprequest.assignment'
    ),
    approveLetters: [],
    changeNewStatusComment: null,
    isChangeToCentralLevelStatusOpened: false,
  }),
  computed: {
    calloutIsOpen() {
      return this.showing !== null;
    },
    showingStatusTimeline() {
      return this.showing === this.enums.SHOW_ITEMS.STATUS_TIMELINE;
    },
    showingNotifyStatus() {
      return this.showing === this.enums.SHOW_ITEMS.NOTIFY_STATUS;
    },
    showingSignedApproval() {
      return this.showing === this.enums.SHOW_ITEMS.SIGNED_APPROVAL;
    },
    showingApproveLetterHistoryTab() {
      return this.showing === this.enums.SHOW_ITEMS.APPROVE_LETTER_HISTORY;
    },
    showingTeacherAssignment() {
      return (
        this.showing === this.enums.SHOW_ITEMS.TEACHER_ASSIGNMENT &&
        this.hasAssignmentPermission
      );
    },
    showingAmendment() {
      return this.showing === this.enums.SHOW_ITEMS.AMENDMENT;
    },
    canUpdateDirectorName() {
      return (
        (this.isNotified || this.isAssigned) &&
        store.getters.HasPermission(
          'academic.pei.ubicationtechassistance.request.directorname.update'
        )
      );
    },
    getDocumentData() {
      return this.document.data;
    },
    estatusNuevo() {
      return (
        this.item?.status.id === tapRequestStatusesEnum.Nuevo &&
        store.getters.HasPermission('taprequest.changestatusnew')
      );
    },
    canShowApproveLetterHistory() {
      if (!store.getters.HasPermission('taprequest.showapproveletterhistory'))
        return false;

      const statusId = this.item?.status.id;
      const validStatuses = [
        tapRequestStatusesEnum.Aprobado,
        tapRequestStatusesEnum.Notificado,
        tapRequestStatusesEnum.Asignado,
        tapRequestStatusesEnum.Enmendado,
        tapRequestStatusesEnum.NoVigenteEgreso,
        tapRequestStatusesEnum.NoVigenteBaja,
      ];

      return validStatuses.some((id) => id == statusId);
    },
    canAmendNotifiedRequest() {
      return (
        this.item?.status.id === tapRequestStatusesEnum.Notificado &&
        store.getters.HasPermission('taprequest.amend')
      );
    },
    canReturnStatus() {
      const returnableStatuses = [
        tapRequestStatusesEnum.Sometido,
        tapRequestStatusesEnum['Recomendado a Evaluación de Nivel Central'],
      ];
      const canReturnRecommendedToSecretary =
        store.getters.HasPermission(
          'ubicationtechassistance.returnrecommendedtosecretary'
        ) &&
        (this.item?.status.id ===
          tapRequestStatusesEnum['Recomendado al(la) Secretario(a)'] ||
          this.item?.status.id === tapRequestStatusesEnum['No Recomendado']);

      return (
        returnableStatuses.some(
          (statusId) => statusId === this.item?.status.id
        ) || canReturnRecommendedToSecretary
      );
    },
    isSubmitted() {
      return this.item?.status.id === tapRequestStatusesEnum.Sometido;
    },
    isApproved() {
      return this.item?.status.id === tapRequestStatusesEnum.Aprobado;
    },

    isConversion() {
      return this.item?.requestType === requesTypes.conversion;
    },
    showYellowMessage() {
      return this.isApproved && this.isConversion;
    },
    isNotified() {
      return this.item?.status.id === tapRequestStatusesEnum.Notificado;
    },
    canPrintAnalysis() {
      return (
        this.item?.status.id === tapRequestStatusesEnum.Aprobado ||
        this.item?.status.id === tapRequestStatusesEnum.Notificado ||
        this.item?.status.id === tapRequestStatusesEnum['No Aprobado']
      );
    },
    isApprovedRefund() {
      return (
        (this.isNotified ||
          this.isAssigned ||
          this.isAmend ||
          this.isNoVigenteBaja ||
          this.isNoValidityEgress) &&
        this.item?.determinationType === determinationTypeEnum.Reembolso &&
        this.approvedDate
      );
    },
    isApprovedDirectPayment() {
      return (
        (this.isNotified ||
          this.isAssigned ||
          this.isAmend ||
          this.isNoVigenteBaja ||
          this.isNoValidityEgress) &&
        this.item?.determinationType === determinationTypeEnum.PagoDirecto &&
        this.approvedDate
      );
    },
    isApprovedPurchaseService() {
      return (
        (this.isNotified ||
          this.isAssigned ||
          this.isAmend ||
          this.isNoVigenteBaja ||
          this.isNoValidityEgress) &&
        this.item?.determinationType === determinationTypeEnum.CompraServicio &&
        this.approvedDate
      );
    },
    isAssignedToTeacher() {
      return (
        this.item?.status.id === tapRequestStatusesEnum.Asignado ||
        this.item?.status.id === tapRequestStatusesEnum.Enmendado ||
        this.item?.status.id ===
          tapRequestStatusesEnum['Proceso de Enmienda'] ||
        this.item?.status.id === tapRequestStatusesEnum.NoVigenteBaja ||
        this.item?.status.id === tapRequestStatusesEnum.NoVigenteEgreso
      );
    },
    isAmendment() {
      return this.item?.isAmendment;
    },
    isAssigned() {
      return this.item?.status.id === tapRequestStatusesEnum.Asignado;
    },
    isAmend() {
      return this.item?.status.id === tapRequestStatusesEnum.Enmendado;
    },
    isAmendProcess() {
      return (
        this.item?.status.id === tapRequestStatusesEnum['Proceso de Enmienda']
      );
    },
    showAmendedMessage() {
      return (
        this.item?.isAmendment &&
        this.item.filterStatus ==
          tapRequestStatusesEnum['Proceso de Análisis del(la) Secretario(a)'] &&
        this.item?.status.id ===
          tapRequestStatusesEnum['Proceso de Análisis del(la) Secretario(a)']
      );
    },
    canReturnCentralLevel() {
      return (
        this.item?.status.id === tapRequestStatusesEnum.Denegado &&
        store.getters.HasPermission('taprequest.changecentrallevelstatus')
      );
    },
    isNoValidityEgress() {
      return this.item?.status.id === tapRequestStatusesEnum.NoVigenteEgreso;
    },
    companyId() {
      return this.userProfile.companyid;
    },
    isAssistantOrProvider() {
      return [userRoles.provider, userRoles.assistantprovider].includes(
        this.userRole
      );
    },
    alternativeLocationTabIdx() {
      if (this.isAssignedToTeacher) {
        return this.isAmend ? TAB_ITEMS.Fourth : TAB_ITEMS.Third;
      }

      return TAB_ITEMS.Second;
    },
    directorNameTabIdx() {
      return [
        this.isAssignedToTeacher,
        this.isAmend,
        this.showHistoryTab,
        !this.showYellowMessage,
        !this.showYellowMessage,
        this.canShowApproveLetterHistory,
        this.showAmendmentDocument,
      ].filter(Boolean).length;
    },
    serviceSummaryTabIdx() {
      if (this.isAssignedToTeacher) {
        return this.isAmend ? TAB_ITEMS.Fiveth : TAB_ITEMS.Fourth;
      }

      return TAB_ITEMS.Third;
    },
    hasBeenApproved() {
      return (
        this.isApproved ||
        this.isNotified ||
        this.isAssignedToTeacher ||
        this.isAmendProcess
      );
    },
    showAmendmentDocument() {
      return (
        this.item?.history?.documentId &&
        this.isAmendProcess &&
        this.isAssistantOrProvider
      );
    },
    showAmendmentHistory() {
      return (
        this.isAmendment &&
        [
          tapRequestStatusesEnum.Enmendado,
          tapRequestStatusesEnum['Proceso de Enmienda'],
          tapRequestStatusesEnum['Recomendado a Evaluación de Nivel Central'],
          tapRequestStatusesEnum['Recomendado al(la) Secretario(a)'],
          tapRequestStatusesEnum.Aprobado,
          tapRequestStatusesEnum.Notificado,
          tapRequestStatusesEnum.Asignado,
        ].includes(this.item?.status.id)
      );
    },
    alternativeLocation() {
      return (location) => {
        return [
          {
            info: [
              {
                label: 'Nombre de Alternativa:',
                data: location.alternativeLocationCategory?.name,
                class: 'col-12 col-md-4',
              },
              {
                label: 'Cantidad de Estudiantes:',
                data: location.numberOfStudents?.name,
                class: 'col-12 col-md-4',
              },
              {
                label: 'Grado:',
                data: location.grade?.name,
                class: 'col-12 col-md-4',
              },
              {
                label: 'Comentario:',
                data: location.comment,
                class: 'col-12',
              },
            ],
          },
        ];
      };
    },
    approvedDate() {
      return moment(this.item.assignedData.minAssingDate)
        .add(-1, 'days')
        .toDate();
    },
    teacherAssignmentMinStartDate() {
      const assignmentStartDate = this.item?.assignedData?.assignmentStartDate;

      if (
        this.item?.hasRetroactivePaymentAuthorization !== true ||
        !assignmentStartDate
      ) {
        return this.approvedDate;
      }

      const retroactiveStartMonth = moment(assignmentStartDate).startOf(
        'month'
      );

      return retroactiveStartMonth.isValid()
        ? retroactiveStartMonth.toDate()
        : this.approvedDate;
    },
    isNoVigenteBaja() {
      return this.item?.status?.id === tapRequestStatusesEnum.NoVigenteBaja;
    },
    isLastStatusNoVigenteBaja() {
      return this.item?.lastStatusId === tapRequestStatusesEnum.NoVigenteBaja;
    },
    showRecommendedCentralLevel() {
      return this.isNoVigenteBaja && !this.isAssistantOrProvider;
    },
    hasAmendment() {
      return this.item && this.item.hasAmendment;
    },
    hasDetermination() {
      return this.item && this.item.determinationType != null;
    },
    showChangeToAmendProcess() {
      return this.isAmend && !this.hasAmendment && !this.isAssistantOrProvider;
    },
    canViewNotifiedAndPrintLetter() {
      return (
        this.showYellowMessage &&
        this.item?.status.id === tapRequestStatusesEnum.Aprobado &&
        this.item?.determinationType === determinationTypeEnum.Reembolso
      );
    },
    showHistoryTab() {
      // US:51819 - hide history tab.
      return false;
    },
    showDeniedReazon() {
      return this.item?.status.id === tapRequestStatusesEnum['Denegado'];
    },
  },
  watch: {
    itemResult: {
      handler(value) {
        this.item = { ...value };
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.item = { ...this.itemResult };
  },
  methods: {
    async fetchDetails(show = null) {
      const item = this.item;
      const hasDetails = item?.hasDetails;
      if (show && !hasDetails && !this.calloutIsOpen) {
        const response = await _getTapRequestHistoryDetails(item.id).catch(
          (error) => {
            this.ShowToast('Error', error.response.data.message, 'error');
          }
        );
        if (response?.data) {
          this.item = {
            ...item,
            ...response.data,
            hasDetails: true,
          };
        }
      }
    },
    async getApproveLetterHistory() {
      const item = this.item ?? {};
      const params = {
        studentSieId: item?.student?.sie,
        academicYearId: item?.academicYearId,
      };
      const { data } = await getTabRequestApproveLetterHistory(params);

      this.approveLetters = data;
    },
    async toggleCallout(show = null, activeTabIdx = null) {
      await this.fetchDetails(show);
      this.activeTab = activeTabIdx ?? TAB_ITEMS.First;
      this.showing = this.showing === show ? null : show;
    },
    toogleAssigment() {
      if (this.item.hasBillingInfo) {
        this.ShowToast(
          'Error',
          'No es posible hacer la modificación de la asignación ya que cuenta con una factura sometida en sistema.',
          'error'
        );
        return false;
      }
      this.toggleCallout(this.enums.SHOW_ITEMS.TEACHER_ASSIGNMENT);
    },
    handleCommentHistoryRedirect(item) {
      this.$router.push({
        path: `/student/comments/commentshistory/${item.student.sie}/${commentTypes.ManejoConsultaUbicacionEstudiante}`,
      });
    },
    async notifyRequest() {
      if (this.item?.determinationType !== determinationTypeEnum.Reembolso) {
        this.toggleCallout(this.enums.SHOW_ITEMS.NOTIFY_STATUS);
        return;
      }

      const confirmed = await this.ShowCancelModal(
        'Confirmación',
        `¿Esta seguro desea cambiar el estatus de Aprobado a Notificado?`,
        'Sí',
        'No'
      );

      if (confirmed) {
        const payload = {
          requestId: this.item.id,
          directorName: 'No Aplica',
        };

        await this.$ApiPost('/api/tapRequests/notification', payload)
          .then(() => {
            this.ShowToast(
              'Proceso Exitoso',
              'La solicitud ha sido cambiada de estatus exitosamente.',
              'success'
            );
            this.$emit('status-has-changed');
          })
          .catch((error) => {
            this.ShowToast('Error', error.response.data.message, 'error');
          });
      }
    },
    async getSignedApprovalDocument() {
      await DocumentsService.downloadFromServer(
        this.item.signedApprovalDocumentId
      );
    },
    async downloadRefundReport() {
      const params = {
        requestId: this.item.id,
      };
      await getTapRequestRefundReport(params).then((response) => {
        DocumentsService.Download(response.data);
      });
    },
    async downloadDirectPaymentReport() {
      const params = {
        requestId: this.item.id,
      };
      await getTapRequestDirectPayment(params).then((response) => {
        DocumentsService.Download(response.data);
      });
    },
    async downloadPurchaseService(requestId) {
      const params = {
        requestId: requestId,
      };
      await getTapRequestPurchaseService(params).then((response) => {
        DocumentsService.Download(response.data);
      });
    },
    async downloadRequestReport() {
      await getTapRequestReport(this.item.id).then((response) => {
        DocumentsService.Download(response.data);
      });
    },
    openReturnCentralLevelPanel() {
      this.showing = this.enums.SHOW_ITEMS.RETURN_TO_CENTRAL_LEVEL;
      this.isChangeToCentralLevelStatusOpened = true;
    },
    async saveChangeReturnToCentralLevelStatus() {
      const valid = await this.$refs.returnStatusForm.validate();
      if (!valid) return;

      try {
        await _changeStatus(this.item.id, {
          statusId:
            tapRequestStatusesEnum['Proceso de Análisis de Nivel Central'],
          reason: this.changeNewStatusComment,
        });

        this.ShowToast(
          '',
          'Cambio de estatus realizado exitosamente.',
          'success'
        );
        this.changeNewStatusComment = null;
        this.showing = null;
        this.isChangeToCentralLevelStatusOpened = false;
        this.$emit('change-status-to-central-level-process');
      } catch (error) {
        this.ShowToast('Alerta', 'Ha ocurrido un error inesperado.', 'error');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.container-message {
  background-color: #fff5e8;
  border: 2px solid #fdac41;
  border-radius: 4px;
  border-top-color: #f7f7f7;
  color: #af6708;
  opacity: 1;
}
::v-deep(.retroactive-badge) {
  background-color: #e9f9f1 !important;
  color: #2db782 !important;
  border: 1px solid #2db782 !important;
  font-weight: 600;
  padding: 6px 14px 6px 8px !important;
}

::v-deep(.retroactive-badge .fa-circle) {
  color: #2db782 !important;
}

::v-deep(.retroactive-badge .fa-check) {
  color: white !important;
}

::v-deep(.retroactive-badge .fa-stack) {
  margin-right: 4px;
}
</style>
